export default {
      id: "oc-res-billproject-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-billproject",
      toString: function () {
        return this.url;
      }
    }